import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=15901189"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15901189')) {
      api.createRecord('15901189', component.options)
    } else {
      api.reload('15901189', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=15901189", function () {
      api.rerender('15901189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/Index.vue"
export default component.exports